
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import _ from 'lodash';
import { IColumnHeaders } from 'src/app/models';
import { Helpers } from 'src/app/helpers';
import { LoaderService, PortalService, ReportService } from 'src/app/services';
import { Response } from 'src/app/models/response';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
    selector: 'medpt-report-gridview',
    templateUrl: './gridview.component.html',
    styleUrls: ['./gridview.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GridviewComponent implements OnInit {
  showExportButton: boolean = false;
  //@ViewChild(GridComponent, { static: false }) public kendoGridInstance: GridComponent | undefined;
  @ViewChild(TooltipDirective, { static: true }) public tooltipDir: TooltipDirective | undefined;
  reportLoaded: boolean = false;
  isMedPointReport!: any;
  reportName!: any;
  serviceParentName!: any;
  filterParams!: any;

  public dataSource: GridDataResult = { data: [], total: 0 };
  total: number = 0;
  columns!: IColumnHeaders[];
  public sort: Array<SortDescriptor> = [];
  public pageSize: number = 50;
  public skip: number = 0;

  public sortOption: any = { SortColumn: null, SortOrder: '' };
  public currentPage: number = 0;

  constructor(
    private loaderService: LoaderService,
    private portalService: PortalService,
    private reportService: ReportService    
  ) { }

  ngOnInit(): void {

  }

  sortChange(sort: SortDescriptor[]) {
    // Save the current state of the Grid component
    this.sort = sort;
    let option = {
      "SortColumn": sort != undefined ? sort.length > 0 ? sort[0].field : "" : "",
      "SortOrder": sort != undefined ? sort.length > 0 ? sort[0].dir : "" : ""
    };
    this.sortOption = option;
    this.skip = 0;
    this.currentPage = 0;
    this.loadGridView();
  }

  onPageChange(e: PageChangeEvent) {
    this.skip = e.skip;
    this.currentPage = (e.skip / e.take);
    this.loadGridView();
  }

  getSortParams() {
    return this.sortOption;
  }
  private loadGridView() {
    this.loadReport(this.filterParams, this.isMedPointReport, this.serviceParentName, this.reportName);
  }

  loadReport(filterParams: object, isMedPointReport: boolean, serviceParentName: string, reportName: string, isSkip: boolean = false) {    
    this.filterParams = filterParams;
    this.serviceParentName = serviceParentName;
    this.reportName = reportName;
    this.isMedPointReport = isMedPointReport;    
    this.skip = isSkip ? 0 : this.skip;
    this.total = 0;
    this.columns = [];
    this.showExportButton = false;
    this.dataSource = { data: [], total: 0 };    
    
    this.loaderService.showLoader('Reports may take a few seconds to load. Please wait.');

    let portalInfo = this.portalService.portalConfiguation.getValue();
    let platformId = Helpers.getPlatformId();
    this.reportLoaded = false;
    let reportGridOptions = {
      ...filterParams,
      PageSize: 50,
      PageIndex: this.currentPage + 1,
      SortColumn: this.sortOption.SortColumn,
      SortOrder: this.sortOption.SortOrder,
      ReportType: this.isMedPointReport ? 1 : 0,
      ExportType: 'Excel',
      PlatFormId: platformId,
      PortalId: portalInfo.PortalID,
    };

    let promiseData = this.reportService.getReport(this.serviceParentName, this.reportName, reportGridOptions, false);

    promiseData
      .then((gridData: Response) => {
        if (gridData.Success) {
          this.total = <number>gridData.Data.TotalCount;
          this.currentPage = this.total > this.pageSize ? 0 : this.currentPage;
          this.columns = _.orderBy(gridData.Data.ColumnHeaders, ['Order'], ['asc']);
          this.showExportButton = this.total > 0;
          this.dataSource = { data: JSON.parse(gridData.Data.Data), total: <number>gridData.Data.TotalCount };

          this.reportLoaded = true;

          //Enable this to set auto fit column
          //if (this.reportName != "FAQManagementReport") {
          //  setTimeout(() => {
          //    if (this.kendoGridInstance != undefined) {
          //      this.kendoGridInstance.columns.forEach((column, index) => {
          //        if (this.kendoGridInstance != undefined) {
          //          this.kendoGridInstance.autoFitColumn(column);
          //        }
          //      });
          //    }
          //    this.loaderService.hideLoader();
          //  }, 100);
          //} else {
          this.loaderService.hideLoader();
          //}
        } else {
          this.loaderService.hideLoader();
        }
      })
      .catch(() => {
        this.reportLoaded = true;
        this.loaderService.hideLoader();
      })
      .finally(() => {
        
      });
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (this.tooltipDir != undefined) {
      if ((element.className.indexOf("k-header") != -1 || element.className.indexOf("k-column-title") != -1) && element.offsetWidth < element.scrollWidth) {
        this.tooltipDir.toggle(element);
      } else {
        this.tooltipDir.hide();
      }
    }
  }

}
